import oRequest from '@/libsV2/request.js';
const URL = {
    CONFIGINFO      :'wind/index/configinfo',//获取配置
    UPLOADIMG       :'wind/index/uploadimg',//上传照片
    REPORTADD       :'wind/index/reportadd',//报告添加
    REPORTTYPE      :'wind/index/reporttype',//商品组合类型
    REPORTENERGY    :'wind/index/reportenergy',//报告负荷设置
    REOPRTATTACH    :'wind/index/reportattach',//报告附件
    GETADDRESS      :'comm/district/gettree',//地址三级联动
    GETTREE         :'comm/district/gettreeV2',//地址三级联动
    REPORTINGO      :'wind/index/reportinfo',//报告详情
    ROOMENERGY      :'wind/index/roomenergy',//报告详情
    GETWIND         :'shop/goods/wind',//获取风盘
    GETFLOORHEAT    :'shop/goods/floorHeating',//地暖商品
    GETHEATSINK     :'shop/goods/heatSink',//散热片商品
    GETUPLOADIMG    :'act/poster/uploadimg',//上传图片
    GETPOSTERADD    :'act/poster/posteradd',//添加海报
    // REPORTPRE       :'wind/index/reportpre',//获取选型商品
    REPORTPRE       :'wind/index/reportprev2',//获取选型商品
    REPORTPRODUCT   :'wind/index/reportproduct',//报告选型添加
    ROOMADD         :'wind/index/roomadd',//房间添加
    GETCITYID       :'comm/district/get_city_id',//转城市id （库里）
    GETCITYINFO     :'comm/district/getinfo',//获取城市信息
    GETGEOCODER     :'tool/location/geocoder', // 根据地址获取经纬度
    ROOMDEL         :'wind/index/roomdel', // 删除楼层
    REPORTAMOUNT    :'wind/index/reportamount', // 套餐报价
    REPORTPRODUCTAMOUNT    :'wind/index/reportproductamount', // 系统报价
    DRAFT_SAVE      :'wind/index/draftsave',
    POSTER_AUTH:'act/poster/postercheck',//喜报白名单鉴权
}

export default{
    posterAuth(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.POSTER_AUTH,oData)
    },
    getFloorHeating(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETFLOORHEAT,oData)
    },
    getHeatSink(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETHEATSINK,oData)
    },
    getPosteradd(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETPOSTERADD,oData)
    },
    getUploadimg(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETUPLOADIMG,oData)
    },
    reportproductamount(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTPRODUCTAMOUNT,oData)
    },
    reportamount(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTAMOUNT,oData)
    },
    delRoom(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.ROOMDEL,oData)
    },
    getCityId(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETCITYID,oData)
    },
    getCityInfo(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETCITYINFO,oData)
    },
    reportproduct(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTPRODUCT,oData)
    },
    roomAdd(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.ROOMADD,oData)
    },
    reportPre(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTPRE,oData)
    },
    getWind(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETWIND,oData)
    },
    getConfigInfo(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.CONFIGINFO,oData)
    },
    roomEnergy(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.ROOMENERGY,oData)
    },
    getReportInfo(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTINGO,oData)
    },
    uploadImg(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.UPLOADIMG,oData)
    },
    reportAdd(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTADD,oData)
    },
    reportType(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTTYPE,oData)
    },
    reportEnergy(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORTENERGY,oData)
    },
    reportAttach(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REOPRTATTACH,oData)
    },
    getTree(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETTREE,oData)
    },
    getAddress(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETADDRESS,oData)
    },
    getGeoCoder(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.GETGEOCODER,oData)
    },
    draftSave (data = {}) {
        let oData = Object.assign({},data);
        return oRequest.getData(URL.DRAFT_SAVE,oData)
    }
}
